import { Form, Input, type InputProps } from 'antd'
import type { ReactNode } from 'react'

import { buildBrowserEmailRule } from '../utils/browserValidation'

type EmailInputProps = {
  label: ReactNode
  name: string
} & Omit<InputProps, 'name'>

export const EmailInput = ({
  autoFocus = false,
  label,
  name,
  placeholder = 'jonathan.smith@example.com'
}: EmailInputProps) => (
  <Form.Item
    name={name}
    label={label}
    style={{ marginBottom: 0 }}
    rules={[buildBrowserEmailRule()]}
  >
    <Input
      type="email"
      inputMode="email"
      spellCheck={false}
      placeholder={placeholder}
      autoComplete="email"
      autoFocus={autoFocus}
    />
  </Form.Item>
)
